import { useQuery } from 'react-query';
import services from 'services/services';

// Import helpers
import { PAYMENT_SETTINGS_QUERY } from 'helpers';

const usePaymentSettings = () => {
	const url = `/payments/checkout/settings`;

	return useQuery(
		PAYMENT_SETTINGS_QUERY,
		async () => (await services.get(url)).data,
		{ refetchOnWindowFocus: false }
	);

	
};

export default usePaymentSettings;
